export interface Simulation {
    id?: string;
    name: string;
    note?: string;
    simulationIdToCopy?: string | null;
}

export const defaultSimulation: Simulation = {
    id: '',
    name: '',
    note: ''
};
